import { UserRequestDraft, UserService } from '@/api/types';

import { InsuranceServiceMergedSchema } from '../model/types';

interface Props {
  requestId: UserRequestDraft['id'];
  formData: InsuranceServiceMergedSchema;
  service: UserService;
}

export const generatePayload = ({ requestId, service, formData }: Props): Record<string, any> => {
  const insuredDocument = formData.documents[formData.insuredDocument.code];

  return {
    request_id: requestId,
    service: {
      id: service.id,
      name: service.name,
      code: service.code,
    },
    order: formData.insuranceProduct,
    user: {
      email: formData.email,
      phone_number: formData.phone,
      birthday: formData.birthday,
    },
    address: {
      country_id: formData.insuredAddress.country.id,
      country_name: formData.insuredAddress.country.label,
      region_id: formData.insuredAddress.region.id,
      region_name: formData.insuredAddress.region.label,
      district_id: formData.insuredAddress.district?.id,
      district_name: formData.insuredAddress.district?.label,
      settlement_id: formData.insuredAddress.settlement.id,
      settlement_name: formData.insuredAddress.settlement.label,
      street_id: formData.insuredAddress.street.id,
      street_name: formData.insuredAddress.street.label,
      house: formData.insuredAddress.house,
      building: formData.insuredAddress.building,
      apartment: formData.insuredAddress.apartment,
      zip_code: formData.insuredAddress.zip_code,
    },
    document: {
      type: formData.insuredDocument.code,
      ...insuredDocument.info,
    },
    start_from: formData.insuranceStartDate,
    confirm: formData.confirmEnteredDataCorrect,
    consent: true,
    // always true cause back-end need it for services in legacy design
    // but in new design there is no this checkbox anymore
  };
};
